import VueCropper from 'vue-cropper';
import VueClipboard from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload';
import Vue from 'vue';
import Component from 'vue-class-component';
import {
  Button,
  Message,
  Carousel,
  CarouselItem,
  Select,
  Option,
  Table,
  TableColumn,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  MessageBox,
  Dialog,
  Form,
  FormItem,
  Input,
  Tabs,
  TabPane,
  Autocomplete,
  InputNumber,
  Pagination,
  Radio,
  Cascader,
  Loading,
  Switch,
  Menu,
  DatePicker,
  Tooltip,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Rate,
  Popover,
  Tag,
  Checkbox
} from 'element-ui';
import { readCookie } from '@/tools/tools';
import Viewer from 'v-viewer';
import DonMessage from '@/tools/message';
import infiniteScroll from 'vue-infinite-scroll';
import { QWebChannel } from '@/tools/qwebchannel';
import App from './App.vue';
import router from './router';
import store from './store/index';
import '@/assets/styles/index.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'viewerjs/dist/viewer.css';

try {
  new QWebChannel((window as any).qt.webChannelTransport, (channel: any) => {
    Vue.prototype.webTransport = channel.objects.webTransport;
  });
} catch {}
Vue.use(infiniteScroll);
Vue.use(VueLazyload);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
});
Vue.use(VueCropper);
Vue.use(VueClipboard);
Vue.use(Button);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tooltip);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Autocomplete);
Vue.use(InputNumber);
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(Cascader);
Vue.use(Loading);
Vue.use(Switch);
Vue.use(DatePicker);
Vue.use(Rate);
Vue.use(Popover);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = DonMessage;
Vue.prototype.$msgbox = MessageBox;
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (to.matched.some((record) => record.meta.requireAuth)) {
    setTimeout(() => {
      // 判断该路由是否需要登录权限
      if (readCookie('accessToken')) {
        // 判断当前的token是否存在 ； 登录存入的token
        next();
      } else {
        next({
          name: 'login',
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    }, 100);
  } else {
    next();
  }
});
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
